import { render, staticRenderFns } from "./verticalItem.vue?vue&type=template&id=5ccef871"
import script from "./verticalItem.vue?vue&type=script&lang=js"
export * from "./verticalItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports